<template>
	<div
		class="modal fade"
		id="modal-material"
		data-backdrop="static"
	>
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="container-fluid">
					<div class="row align-items-center justify-content-between">
						<div class="col-12 position-relative">
							<div
								class="d-block mx-auto pt-5 pb-4 text-center max-350"
							>
								<h4 class="font-24 m-0">
									{{
										type == 'config' ? 'CONFIGURAR' : 'NOVO'
									}}
									MATERIAL
								</h4>
							</div>
							<button
								type="button"
								class="position-absolute btn btn-light p-3 ps-r-0 ps-t-0 m-3"
								@click="Close"
							>
								<i class="far fa-times mx-1"></i>
							</button>
						</div>
						<div class="col-12">
							<div
								class="scroll-x scroll-transparent d-flex mx--5 mx-md-0"
							>
								<ul
									class="nav nav-pills nav-theme w-md-100 justify-content-md-center my-4 my-md-5 px-5"
									:class="{
										'd-none': type == 'new',
									}"
								>
									<li class="nav-item">
										<a
											class="nav-link pb-md-4 px-md-4 active"
											data-toggle="tab"
											href="#info"
										>
											DADOS
										</a>
									</li>
									<li
										class="nav-item"
										v-if="type == 'config'"
									>
										<a
											class="nav-link pb-md-4 px-md-4"
											data-toggle="tab"
											href="#partnerships"
										>
											CONVÊNIOS
										</a>
									</li>
								</ul>
							</div>
							<div class="tab-content">
								<div
									id="info"
									class="tab-pane active"
								>
									<div class="col">
										<div class="w-full">
											<div class="w-full align-items-center">
												<div class="w-full">
													<MaterialTypeCheckboxes
														:value="form.material_type"
														:disabled="type_locked"
														@input="form.material_type = $event"
													/>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-12">
												<div class="form-group">
													<label>NOME</label>
													<input
														type="text"
														v-model="
															$v.form.name.$model
														"
														@input="
															$v.form.name.$model =
																$event.target.value.toUpperCase()
														"
														class="form-control"
														:class="{
															'is-invalid':
																$v.form.name
																	.$error,
														}"
														ref="name"
													/>
													<div
														class="invalid-feedback"
														v-if="
															!$v.form.name
																.required
														"
													>
														OBRIGATÓRIO
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-12 col-md-4">
												<div class="form-group">
													<label
														>CÓDIGO DO
														MATERIAL</label
													>
													<input
														type="text"
														v-model="
															form.internal_code
														"
														@input="
															form.internal_code =
																$event.target.value.toUpperCase()
														"
														class="form-control"
													/>
												</div>
											</div>
											<div class="col-12 col-md-4">
												<div class="form-group">
													<label
														>UNIDADE DO
														MATERIAL</label
													>
													<input
														type="text"
														v-model="form.unit"
														@input="
															form.unit =
																$event.target.value.toUpperCase()
														"
														class="form-control"
													/>
												</div>
											</div>
											<div class="col-12 col-md-4">
												<div class="form-group">
													<label
														>VALOR UNITÁRIO DA
														UNIDADE</label
													>
													<money
														v-model="
															form.unity_value
														"
														class="form-control"
													/>
												</div>
											</div>
										</div>
										<div class="row px-1">
											<fieldset
												class="col mx-3 mb-3 px-3"
											>
												<legend>ALÍQUOTA</legend>
												<div
													class="row justify-content-end align-items-center"
												>
													<div class="col-md">
														<div class="form-group">
															<label>TIPO</label>
															<select
																v-model="
																	form.aliquot_type
																"
																class="form-control"
															>
																<option
																	:value="1"
																>
																	VALOR
																</option>
																<option
																	:value="2"
																>
																	PORCENTAGEM
																</option>
															</select>
														</div>
													</div>
													<div class="col-md">
														<div class="form-group">
															<label
																>PORCENTAGEM</label
															>
															<input
																type="number"
																:disabled="
																	form.aliquot_type ===
																	1
																"
																v-model="
																	form.aliquot_percentage
																"
																min="0"
																class="form-control"
															/>
														</div>
													</div>
													<div class="col-md">
														<div class="form-group">
															<label
																>VALOR DA
																ALÍQUOTA</label
															>
															<money
																:disabled="
																	form.aliquot_type ===
																	2
																"
																v-model="
																	form.aliquot_value
																"
																class="form-control"
															/>
														</div>
													</div>
												</div>
											</fieldset>
										</div>
										<div class="row px-1">
											<fieldset
												class="col mx-3 mb-3 px-3"
											>
												<legend>HONORÁRIO</legend>
												<div
													class="row justify-content-end align-items-center"
												>
													<div class="col-md">
														<div class="form-group">
															<label>TIPO</label>
															<select
																v-model="
																	form.honorary_type
																"
																class="form-control"
															>
																<option
																	:value="1"
																>
																	VALOR
																</option>
																<option
																	:value="2"
																>
																	PORCENTAGEM
																</option>
															</select>
														</div>
													</div>
													<div class="col-md">
														<div class="form-group">
															<label
																>PORCENTAGEM</label
															>
															<input
																type="number"
																:disabled="
																	form.honorary_type ===
																	1
																"
																v-model="
																	form.honorary_percentage
																"
																min="0"
																class="form-control"
															/>
														</div>
													</div>
													<div class="col-md">
														<div class="form-group">
															<label
																>VALOR DO
																HONORÁRIO</label
															>
															<money
																:disabled="
																	form.honorary_type ===
																	2
																"
																v-model="
																	form.honorary_value
																"
																class="form-control"
															/>
														</div>
													</div>
												</div>
											</fieldset>
										</div>
										<div class="row">
											<div class="col-12">
												<div class="form-group">
													<label
														>DESCRIÇÃO DO
														PRODUTO</label
													>
													<Editor
														v-model="
															form.instructions
														"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									id="partnerships"
									class="tab-pane"
								>
									<div
										class="col d-flex justify-content-center"
										v-if="material"
									>
										<div class="w-full">
											<div
												class="row mb-4 justify-content-end align-items-center"
											>
												<div class="col-md">
													<h4
														class="font-24 mt-3 mb-0"
													>
														{{
															material.name.toUpperCase()
														}}
													</h4>
													<p class="font-14">
														CONFIGURE O VALOR
														UNITÁRIO E OS CONVÊNIOS
														DESTE MATERIAL
													</p>
												</div>
												<div class="col-md">
													<div class="form-group">
														<label
															>VALOR BASE DO
															MATERIAL</label
														>
														<money
															v-model="
																form.unity_value
															"
															class="form-control"
															disabled
														/>
													</div>
												</div>
											</div>
											<div
												v-for="(partnership, partnershipIndex) in partnerships"
												:key="partnership.id"
												:class="{
													'opacity-50':
														!partnership.enabled,
												}"
											>
												<div
													class="d-flex align-items-start"
												>
													<h5 class="mb-3">
														{{
															partnership.nome.toUpperCase()
														}}
													</h5>
													<div
														class="form-group m-0 ml-3 form-check"
													>
														<input
															type="checkbox"
															:id="`part${partnership.id}`"
															class="bg-danger"
															v-model="
																partnership.enabled
															"
															@change="OnPartnershipEnabledChange(partnership)"
														/>
														<label
															:for="`part${partnership.id}`"
														></label>
													</div>
												</div>
												<fieldset>
													<legend>
														IDENTIFICAÇÃO
													</legend>
													<div
														class="row justify-content-end align-items-center"
													>
														<div class="col-md">
															<div
																class="form-group"
															>
																<FormGroup
																	v-model="partnership.tuss_code"
																	formatter="numbers"
																	class="col-span-3"
																	label="Código"
																	placeholder="TUSS"
																	:omit-info="true"
																	:required="isPartnershipTissAndEnabled(partnership)"
																	:disabled="!isPartnershipTissAndEnabled(partnership)"
																	:input-classes="[
																		{
																			'field-error': isPartnershipTissAndEnabled(partnership) && (partnership.has_tuss_error || $v.partnerships.$each[partnershipIndex].tuss_code.$error),
																			force: partnership.has_tuss_error,
																			'tuss-code-not-found': partnership.has_tuss_error,
																		},
																	]"
																	@input.native="ClearTussSearchResult(partnership)"
																	@keydown.native.enter.prevent="SearchTussCode(partnership)"
																/>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<FormGroup
																	v-model="partnership.tuss_description"
																	formatter="alphanumeric"
																	class="col-span-3"
																	label="Descrição"
																	placeholder=""
																	:omit-info="true"
																	:readonly="isPartnershipTissAndEnabled(partnership)"
																	:required="isPartnershipTissAndEnabled(partnership)"
																	:disabled="!isPartnershipTissAndEnabled(partnership)"
																	:input-classes="[
																		{
																			'field-error': isPartnershipTissAndEnabled(partnership) && (partnership.has_tuss_error || $v.partnerships.$each[partnershipIndex].tuss_description.$error),
																			force: partnership.has_tuss_error,
																			'tuss-description-not-found': partnership.has_tuss_error,
																		},
																	]"
																/>
															</div>
														</div>
													</div>
												</fieldset>
												<fieldset>
													<legend>
														UNIDADE DE MEDIDA
													</legend>
													<div
														class="row justify-content-end align-items-center"
													>
														<div class="col-md">
															<div
																class="form-group"
															>
																<FormGroup
																	v-model="partnership.measurement_unit"
																	formatter="alphanumeric"
																	class="col-span-3"
																	label="UNIDADE DE MEDIDA"
																	placeholder="SELECIONE..."
																	input-type="select"
																	:omit-info="true"
																	:required="isPartnershipTissAndEnabled(partnership)"
																	:disabled="!isPartnershipTissAndEnabled(partnership)"
																	:options="GetFilteredMeasurementUnits(partnership)"
																	:intercept-select="true"
																	:min-length="0"
																	:input-classes="[
																		{
																			'field-error': isPartnershipTissAndEnabled(partnership) && $v.partnerships.$each[partnershipIndex].measurement_unit.$error,
																		},
																	]"
																	@input.native="FilterMeasurementUnits(partnership, $event)"
																	@click.native="FilterMeasurementUnits(partnership, null)"
																	@select="SelectMeasurementUnit(partnership, $event)"
																/>
															</div>
														</div>
													</div>
												</fieldset>
												<fieldset>
													<legend>
														MATERIAIS
													</legend>
													<div
														class="row justify-content-end align-items-center"
													>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>TIPO</label
																>
																<select
																	v-model="
																		partnership.value_type
																	"
																	class="form-control"
																	:disabled="
																		!partnership.enabled
																	"
																>
																	<option
																		:value="
																			1
																		"
																	>
																		VALOR
																	</option>
																	<option
																		:value="
																			2
																		"
																	>
																		PORCENTAGEM
																	</option>
																</select>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>PORCENTAGEM</label
																>
																<input
																	type="number"
																	:disabled="
																		!partnership.enabled ||
																		partnership.value_type ===
																			1
																	"
																	v-model="
																		partnership.percentage
																	"
																	min="0"
																	class="form-control"
																/>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>VALOR DO
																	MATERIAL</label
																>
																<money
																	:disabled="
																		!partnership.enabled ||
																		partnership.value_type ==
																			2
																	"
																	v-model="
																		partnership.value
																	"
																	class="form-control"
																/>
															</div>
														</div>
													</div>
												</fieldset>
												<fieldset>
													<legend>ALÍQUOTA</legend>
													<div
														class="row justify-content-end align-items-center"
													>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>TIPO</label
																>
																<select
																	v-model="
																		partnership.aliquot_type
																	"
																	class="form-control"
																	:disabled="
																		!partnership.enabled
																	"
																>
																	<option
																		:value="
																			1
																		"
																	>
																		VALOR
																	</option>
																	<option
																		:value="
																			2
																		"
																	>
																		PORCENTAGEM
																	</option>
																</select>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>PORCENTAGEM</label
																>
																<input
																	type="number"
																	:disabled="
																		!partnership.enabled ||
																		partnership.aliquot_type ===
																			1
																	"
																	v-model="
																		partnership.aliquot_percentage
																	"
																	min="0"
																	class="form-control"
																/>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>VALOR DA
																	ALÍQUOTA</label
																>
																<money
																	:disabled="
																		!partnership.enabled ||
																		partnership.aliquot_type ===
																			2
																	"
																	v-model="
																		partnership.aliquot_value
																	"
																	class="form-control"
																/>
															</div>
														</div>
													</div>
												</fieldset>
												<fieldset>
													<legend>HONORÁRIO</legend>
													<div
														class="row justify-content-end align-items-center"
													>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>TIPO</label
																>
																<select
																	v-model="
																		partnership.honorary_type
																	"
																	class="form-control"
																	:disabled="
																		!partnership.enabled
																	"
																>
																	<option
																		:value="
																			1
																		"
																	>
																		VALOR
																	</option>
																	<option
																		:value="
																			2
																		"
																	>
																		PORCENTAGEM
																	</option>
																</select>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>PORCENTAGEM</label
																>
																<input
																	type="number"
																	:disabled="
																		!partnership.enabled ||
																		partnership.honorary_type ===
																			1
																	"
																	v-model="
																		partnership.honorary_percentage
																	"
																	min="0"
																	class="form-control"
																/>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<label
																	>VALOR DO
																	HONORÁRIO</label
																>
																<money
																	:disabled="
																		!partnership.enabled ||
																		partnership.honorary_type ===
																			2
																	"
																	v-model="
																		partnership.honorary_value
																	"
																	class="form-control"
																/>
															</div>
														</div>
													</div>
												</fieldset>
												<fieldset>
													<legend>
														OPME NÃO CADASTRADO NA TUSS
													</legend>
													<div
														class="row justify-content-end align-items-center"
													>
														<div class="col-md">
															<div
																class="form-group"
															>
																<FormGroup
																	v-model="partnership.anvisa_registration"
																	formatter="numbers"
																	class="col-span-3"
																	label="REGISTRO ANVISA"
																	:max-length="15"
																	placeholder=""
																	:omit-info="true"
																	:required="false"
																	:disabled="!isPartnershipTissAndEnabled(partnership) || !isOpmeMaterialType()"
																/>
															</div>
														</div>
														<div class="col-md">
															<div
																class="form-group"
															>
																<FormGroup
																	v-model="partnership.manufacturer_code"
																	formatter="numbers"
																	class="col-span-3"
																	label="CÓDIGO DO FABRICANTE"
																	:max-length="30"
																	placeholder=""
																	:omit-info="true"
																	:required="false"
																	:disabled="!isPartnershipTissAndEnabled(partnership) || !isOpmeMaterialType()"
																/>
															</div>
														</div>
													</div>
												</fieldset>
												<fieldset>
													<legend>
														COBRANÇA DE OPME
													</legend>
													<div
														class="row justify-content-end align-items-center"
													>
														<div class="col-md">
															<div
																class="form-group"
															>
																<FormGroup
																	v-model="partnership.opme_company_authorization_number"
																	formatter="numbers"
																	class="col-span-3"
																	label="NÚMERO DE AUTORIZAÇÃO DA EMPRESA DO OPME"
																	:max-length="60"
																	placeholder=""
																	:omit-info="true"
																	:required="false"
																	:disabled="!isPartnershipTissAndEnabled(partnership) || !isOpmeMaterialType()"
																/>
															</div>
														</div>
													</div>
												</fieldset>
												<hr />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 text-center pt-5 pb-3">
							<div class="d-flex justify-content-between">
								<button
									class="btn btn-danger px-md-5"
									@click="Close"
								>
									VOLTAR
								</button>
								<button
									class="btn btn-success px-md-5"
									@click="Save"
								>
									SALVAR
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const _ = require('lodash')
	import { required } from 'vuelidate/lib/validators'
	import { mapActions, mapGetters } from 'vuex'
	import { useConfirmation, useDeleteAlert, useError, useMaterialTypeWarning } from '@/composables'
	import Editor from '@/components/shared/Editor'
	import MaterialTypeCheckboxes from './MaterialTypeCheckboxes.vue'

	export default {
		name: 'MaterialForm',
		components: {
			Editor,
			MaterialTypeCheckboxes,
		},
		props: {
			open: {
				type: Boolean,
				default: false,
			},
			material: {
				type: Object,
				default: null,
			},
			parent_id: {
				type: [String, Number],
				default: null,
			},
			type: {
				type: String,
				default: 'new', //'config'
			},
			context_material_type: {
				type: Object,
				default: null,
			},
			context_locked: {
				type: Boolean,
				default: false,
			},
			context_locked_level: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				modal: false,
				check_all: false,
				partnerships: [],
				measurementUnits: {},
				allMeasurementUnits: {
					'202601': [],
					'202607': []
				},
				type_locked: false,
				type_locked_level: null,
				form: {
					name: null,
					internal_code: null,
					unit: null,
					unity_value: 0.0,
					instructions: null,
					selected_partnerships: [],
					aliquot_type: 2, // PERCENTAGE
					aliquot_percentage: 0,
					aliquot_value: 0.0,
					honorary_type: 2, // PERCENTAGE
					honorary_percentage: 0,
					honorary_value: 0.0,
					material_type: {
						material: true,
						medical: false,
						opme: false,
						medical_gas: false,
					},
				},
			}
		},
		validations() {
			return {
				form: {
					name: {
						required,
					},
				},
				partnerships: {
					$each: {
						tuss_code: {
							required(value, partnership) {
								return !this.isTussRequired(partnership) || required(value)
							},
							found(value, partnership) {
								return !this.isTussRequired(partnership) || !partnership.has_tuss_error
							},
						},
						tuss_description: {
							required(value, partnership) {
								return !this.isTussRequired(partnership) || required(value)
							},
						},
						measurement_unit: {
							required(value, partnership) {
								return !this.isPartnershipTissAndEnabled(partnership) || required(value)
							},
						},
					},
				}
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id', 'requesters']),
			sum_percent_of_partnerships() {
				let tmp = 0

				this.partnerships.forEach(p => {
					tmp += p.percentage + p.value_type
				})

				return tmp
			},
			sum_percent_of_partnerships_aliquots() {
				let tmp = 0

				this.partnerships.forEach(p => {
					tmp += p.aliquot_percentage + p.aliquot_value
				})

				return tmp
			},
			sum_percent_of_partnerships_honoraries() {
				let tmp = 0

				this.partnerships.forEach(p => {
					tmp += p.honorary_percentage + p.honorary_value
				})

				return tmp
			},
			minutes() {
				let arr = []
				let min = 5

				for (
					let i = 0;
					i < 100;
					i++ //500 MINUTOS
				) {
					arr.push({
						text: `${min.toString().padStart(2, '0')}`,
						value: min,
					})

					min = min + 5
				}

				return arr
			},
		},
		watch: {
			async open(val) {
				if (val && !_.isEmpty(this.material)) {
					if (this.type == 'config') {
						// Carregar unidades de medida antes de buscar os convênios
						if (Object.keys(this.allMeasurementUnits['202601']).length === 0 || 
							Object.keys(this.allMeasurementUnits['202607']).length === 0) {
							await this.LoadAllMeasurementUnits()
						}
						await this.GetPartnershipsWithMaterial()
					}

					this.form.name = this.material.name
					this.form.internal_code = this.material.internal_code
					this.form.unit = this.material.unit
					this.form.unity_value = parseFloat(
						this.material.unity_value
					)
					this.form.instructions = this.material.instructions

					this.form.aliquot_type = parseInt(
						this.material.aliquot_type
					)
					this.form.aliquot_percentage = parseFloat(
						this.material.aliquot_percentage
					)
					this.form.aliquot_value = parseFloat(
						this.material.aliquot_value
					)

					this.form.honorary_type = parseInt(
						this.material.honorary_type
					)
					this.form.honorary_percentage = parseFloat(
						this.material.honorary_percentage
					)
					this.form.honorary_value = parseFloat(
						this.material.honorary_value
					)
					this.form.material_type = this.material.material_type
						? { ...this.material.material_type }
						: {
								material: true,
								medical: false,
								opme: false,
								medical_gas: false,
						  }
					this.type_locked = !!this.material._type_locked
					this.type_locked_level = this.material._type_locked
						? this.material._type_locked_level
						: null
				} else {
					this.form.name = null
					this.form.internal_code = null
					this.form.unit = null
					this.form.unity_value = 0.0
					this.form.instructions = null

					this.form.aliquot_type = 2
					this.form.aliquot_percentage = 0
					this.form.aliquot_value = 0.0

					this.form.honorary_type = 2
					this.form.honorary_percentage = 0
					this.form.honorary_value = 0.0
					this.form.material_type = this.context_material_type
						? { ...this.context_material_type }
						: {
								material: true,
								medical: false,
								opme: false,
								medical_gas: false,
						  }
					this.type_locked = !!this.context_locked
					this.type_locked_level = this.context_locked
						? this.context_locked_level
						: null
				}

				window.jQuery('#modal-material').modal(val ? 'show' : 'hide')

				if (val) {
					this.$nextTick(() => {
						window
							.jQuery('#modal-material .nav-link[href="#info"]')
							.tab('show')
					})
				}
			},
			check_all: {
				handler(val) {
					if (val) {
						this.schedules.forEach(schedule => {
							if (
								!this.form.selected_schedules.includes(
									schedule.id
								)
							) {
								this.form.selected_schedules.push(schedule.id)
							}
						})
					} else {
						this.form.selected_schedules = []
					}
				},
			},
			sum_percent_of_partnerships: {
				handler() {
					this.UpdatePartnershipValue()
				},
			},
			sum_percent_of_partnerships_aliquots: {
				handler() {
					this.UpdatePartnershipAliquotValue()
				},
			},
			sum_percent_of_partnerships_honoraries: {
				handler() {
					this.UpdatePartnershipHonoraryValue()
				},
			},
			'form.unity_value': {
				handler() {
					this.UpdateBaseAliquotValue()
					this.UpdateBaseHonoraryValue()

					this.UpdatePartnershipValue()
				},
			},
			'form.aliquot_percentage': {
				handler() {
					this.UpdateBaseAliquotValue()
				},
			},
			'form.honorary_percentage': {
				handler() {
					this.UpdateBaseHonoraryValue()
				},
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			isPartnershipTissAndEnabled(partnership) {
				return partnership.enabled && partnership.billing_type === 'tiss'
			},
			isOpmeMaterialType() {
				return typeof this.form.material_type === 'object' && this.form.material_type !== null && this.form.material_type.opme
			},
			isTussRequired(partnership) {
				if (!this.isPartnershipTissAndEnabled(partnership)) {
					return false
				}
				if (this.isOpmeMaterialType() && partnership.anvisa_registration && partnership.manufacturer_code) {
					return false
				}
				return true
			},
			ClearTussSearchResult(partnership) {
				partnership.has_tuss_error = false
				partnership.tuss_description = ''
			},
			GetFilteredMeasurementUnits(partnership) {
				const partnershipId = partnership.id

				if (!this.measurementUnits[partnershipId]?.length && this.isPartnershipTissAndEnabled(partnership)) {
					this.FilterMeasurementUnits(partnership, null)
				}

				const options = this.measurementUnits[partnershipId] || []
				const version = partnership.tuss_60_version || '202607'
				const selectedUnit = (this.allMeasurementUnits[version] || []).find(
					unit => unit.value === String(partnership.measurement_unit)
				)

				if (selectedUnit && !options.some(unit => unit.value === selectedUnit.value)) {
					return [selectedUnit, ...options]
				}

				return options
			},
			FilterMeasurementUnits(partnership, event) {
				const searchValue = event?.target?.value?.trim() || ''
				const version = partnership.tuss_60_version || '202607'
				
				if (!this.isPartnershipTissAndEnabled(partnership)) {
					this.$set(this.measurementUnits, partnership.id, [])
					return
				}

				const allUnits = this.allMeasurementUnits[version] || []
				
				if (!searchValue) {
					this.$set(this.measurementUnits, partnership.id, allUnits.slice(0, 50))
					return
				}

				const normalizedSearch = this.normalizeString(searchValue)

				const filtered = allUnits.filter(unit => {
					const normalizedCode = this.normalizeString(unit.code || unit.value || '')
					const normalizedDescription = this.normalizeString(unit.description || '')
					const normalizedDetailedDescription = this.normalizeString(unit.detailed_description || '')
					
					return normalizedCode.includes(normalizedSearch) || 
					       normalizedDescription.includes(normalizedSearch) ||
					       normalizedDetailedDescription.includes(normalizedSearch)
				}).slice(0, 50)

				this.$set(this.measurementUnits, partnership.id, filtered)
			},
			normalizeString(str) {
				if (!str) return ''
				return str
					.toString()
					.toUpperCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
			},
			async LoadAllMeasurementUnits() {
				this.StartLoading()

				try {
					const { data: data202601 } = await window.api.call('post', '/search-tuss-60-terms', {
						account_id: this.requester_selected_id,
						partnership_id: null,
						search: '',
						version: '202601'
					})

					if (data202601?.response && data202601?.terms) {
						this.allMeasurementUnits['202601'] = data202601.terms.map(term => ({
							...term,
							value: String(term.value ?? term.code ?? ''),
							label: term.label,
						}))
					}

					const { data: data202607 } = await window.api.call('post', '/search-tuss-60-terms', {
						account_id: this.requester_selected_id,
						partnership_id: null,
						search: '',
						version: '202607'
					})

					if (data202607?.response && data202607?.terms) {
						this.allMeasurementUnits['202607'] = data202607.terms.map(term => ({
							...term,
							value: String(term.value ?? term.code ?? ''),
							label: term.label,
						}))
					}
				} catch (error) {
					console.error('Erro ao carregar unidades de medida:', error)
				} finally {
					this.FinishLoading()
				}
			},
			SelectMeasurementUnit(partnership, selectedOption) {
				if (selectedOption) {
					const value = typeof selectedOption === 'object' ? selectedOption.value : selectedOption
					partnership.measurement_unit = String(value)

					if (!this.isPartnershipTissAndEnabled(partnership)) return

					const targetVersion = partnership.tuss_60_version || '202607'

					this.partnerships.forEach(currentPartnership => {
						if (
							this.isPartnershipTissAndEnabled(currentPartnership) &&
							(currentPartnership.tuss_60_version || '202607') === targetVersion
						) {
							currentPartnership.measurement_unit = String(value)
						}
					})
				}
			},
			OnPartnershipEnabledChange(partnership) {
				if (!this.isPartnershipTissAndEnabled(partnership) && partnership.has_tuss_error) {
					this.ClearTussSearchResult(partnership)
				}
			},
			GetPartnershipTussVersion(partnership) {
				let type = 1
				if (typeof this.form.material_type === 'object' && this.form.material_type !== null) {
					if (this.form.material_type.medical_gas) {
						type = 4
					} else if (this.form.material_type.medical) {
						type = 2
					} else if (this.form.material_type.opme) {
						type = 3
					} else {
						type = 1
					}
				} else {
					type = parseInt(this.form.material_type, 10)
				}

				if (type === 4) {
					return partnership.tuss_18_version || ''
				} else if (type === 2) {
					return partnership.tuss_20_version || ''
				} else {
					return partnership.tuss_19_version || ''
				}
			},
			async SearchTussCode(partnership) {
				const tussCode = partnership.tuss_code

				if (!this.isPartnershipTissAndEnabled(partnership) || !tussCode) {
					return
				}

				this.StartLoading()

				try {
					const { data } = await window.api.call('post', '/find-tuss-material-term', {
						code: tussCode,
						account_id: this.requester_selected_id,
						partnership_id: partnership.id,
						material_id: this.material.id || null,
						material_type: this.form.material_type,
					})
					const description = data?.term?.description || data?.term?.termo

					if (!data?.response || !description) {
						throw new Error('TUSS code not found')
					}

					const targetVersion = this.GetPartnershipTussVersion(partnership)

					this.partnerships.forEach(currentPartnership => {
						if (
							this.isPartnershipTissAndEnabled(currentPartnership) &&
							this.GetPartnershipTussVersion(currentPartnership) === targetVersion
						) {
							currentPartnership.tuss_code = tussCode
							currentPartnership.tuss_description = description
							currentPartnership.has_tuss_error = false
						}
					})
				} catch (error) {
					partnership.has_tuss_error = true
					partnership.tuss_description = 'CÓDIGO NÃO ENCONTRADO NA TABELA'
				} finally {
					this.FinishLoading()
				}
			},
			async ValidateTussCodesBeforeSave() {
				const activeTissPartnership = this.partnerships.find(
					partnership =>
						this.isPartnershipTissAndEnabled(partnership) &&
						partnership.tuss_code &&
						!partnership.tuss_description
				) || this.partnerships.find(
					partnership =>
						this.isTussRequired(partnership) &&
						!partnership.tuss_description
				)

				if (activeTissPartnership) {
					await this.SearchTussCode(activeTissPartnership)
				}

				return !this.partnerships.some(
					partnership => this.isTussRequired(partnership) && partnership.has_tuss_error
				)
			},
			UpdateBaseAliquotValue() {
				const TYPE_PERCENTAGE = 2

				if (this.form.aliquot_type === TYPE_PERCENTAGE) {
					this.form.aliquot_value =
						parseFloat(this.form.unity_value) *
						(parseFloat(this.form.aliquot_percentage) / 100)
				}
			},
			UpdateBaseHonoraryValue() {
				const TYPE_PERCENTAGE = 2

				if (this.form.honorary_type === TYPE_PERCENTAGE) {
					this.form.honorary_value =
						parseFloat(this.form.unity_value) *
						(parseFloat(this.form.honorary_percentage) / 100)
				}
			},
			UpdatePartnershipValue() {
				if (this.type == 'config') {
					this.partnerships = this.partnerships.map(p => {
						const TYPE_PERCENTAGE = 2

						if (p.value_type == TYPE_PERCENTAGE) {
							p.value =
								parseFloat(this.form.unity_value) *
								(parseFloat(p.percentage) / 100)
						}

						return p
					})

					this.UpdatePartnershipAliquotValue()
					this.UpdatePartnershipHonoraryValue()
				}
			},
			UpdatePartnershipAliquotValue() {
				if (this.loading_data) return

				if (this.type == 'config') {
					this.partnerships = this.partnerships.map(p => {
						const TYPE_PERCENTAGE = 2

						if (p.aliquot_type === TYPE_PERCENTAGE) {
							p.aliquot_value =
								parseFloat(p.value) *
								(parseFloat(p.aliquot_percentage) / 100)
						}

						return p
					})
				}
			},
			UpdatePartnershipHonoraryValue() {
				if (this.loading_data) return

				if (this.type == 'config') {
					this.partnerships = this.partnerships.map(p => {
						const TYPE_PERCENTAGE = 2

						if (p.honorary_type === TYPE_PERCENTAGE) {
							p.honorary_value =
								parseFloat(p.value) *
								(parseFloat(p.honorary_percentage) / 100)
						}

						return p
					})
				}
			},
			async GetPartnershipsWithMaterial() {
				this.StartLoading()

				this.loading_data = true

				this.partnerships = []
				this.form.selected_partnerships = []
				this.check_all = false

				return await window.api
					.call('post', '/get-partnerships-with-material', {
						material_id: this.material.id,
						organization_id: this.requester_selected_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.partnerships = _.sortBy(
								data.partnerships.map(p => {
									let obj = {
										id: p.id,
										nome: p.nome,
										billing_type: p.billing_type || 'default',
										tuss_18_version: p.tuss_18_version || '',
										tuss_19_version: p.tuss_19_version || '',
										tuss_20_version: p.tuss_20_version || '',
										tuss_60_version: p.tuss_60_version || '',
										enabled: false,
										tuss_code: '',
										tuss_description: '',
										has_tuss_error: false,
										anvisa_registration: '',
										manufacturer_code: '',
										opme_company_authorization_number: '',
										measurement_unit: '',
										value_type: 2,
										percentage: 100,
										value: 0.0,
										aliquot_type: 2,
										aliquot_percentage: 100,
										aliquot_value: 0.0,
										honorary_type: 2,
										honorary_percentage: 100,
										honorary_value: 0.0,
									}

									if (p.materials.length) {
										obj.enabled =
											!!p.materials[0].pivot.status

										obj.tuss_code = p.materials[0].pivot.tuss_code || ''
										obj.tuss_description =
											p.materials[0].pivot.tuss_description || ''

										obj.anvisa_registration =
											p.materials[0].pivot.anvisa_registration || ''
										obj.manufacturer_code =
											p.materials[0].pivot.manufacturer_code || ''
										obj.opme_company_authorization_number =
											p.materials[0].pivot.opme_company_authorization_number || ''
										
										obj.measurement_unit =
											p.materials[0].pivot.measurement_unit || ''

										obj.value_type = parseInt(
											p.materials[0].pivot.value_type
										)
										obj.percentage = parseFloat(
											p.materials[0].pivot.percentage
										)
										obj.value = parseFloat(
											p.materials[0].pivot.value
										)

										obj.aliquot_type = parseInt(
											p.materials[0].pivot.aliquot_type
										)
										obj.aliquot_percentage = parseFloat(
											p.materials[0].pivot
												.aliquot_percentage
										)
										obj.aliquot_value = parseFloat(
											p.materials[0].pivot.aliquot_value
										)
										obj.honorary_type = parseInt(
											p.materials[0].pivot.honorary_type
										)
										obj.honorary_percentage = parseFloat(
											p.materials[0].pivot
												.honorary_percentage
										)
										obj.honorary_value = parseFloat(
											p.materials[0].pivot.honorary_value
										)
									}

									return obj
								}),
								p => !p.enabled
							)
						}
					})
					.finally(() => {
						this.FinishLoading()

						this.loading_data = false
					})
			},
			Close() {
				this.$v.$reset()
				this.$emit('close')
			},
			async Save() {
				this.$v.$touch()

				const tussCodesValid = await this.ValidateTussCodesBeforeSave()

				if (!this.$v.$invalid && tussCodesValid) {
					if (this.type === 'config' && !_.isEqual(this.material.material_type, this.form.material_type)) {
						if (!(await useMaterialTypeWarning())) return
					}

					this.StartLoading()

					let obj = {
						...this.form,
						type: 3, // MATERIAL
						organization_id: this.requester_selected_id,
						parent_id: this.parent_id,
						type_locked: this.type_locked,
						type_locked_level: this.type_locked_level,
					}

					if (this.partnerships.length > 0) {
						const partnerships = this.partnerships
							.filter(p => p.enabled)
							.map(({ has_tuss_error, ...partnership }) => partnership)

						if (partnerships.length > 0) {
							obj.partnerships = partnerships
						}
					}

					delete obj.selected_partnerships

					if (this.type == 'new') {
						delete obj.id
					} else {
						obj.id = this.material.id
					}

					await window.api
						.call('post', '/save-material', obj)
						.then(({ data }) => {
							if (data.response) {
								useConfirmation()

								data.material.material_type = {
									...this.form.material_type,
								}
								data.material._type_locked = this.type_locked
								data.material._type_locked_level = this.type_locked_level

								this.$emit('refresh', {
									material: data.material,
									method:
										this.type == 'new'
											? 'create'
											: 'update',
								})

								this.Close()
							} else {
								useError(
									'Houve um erro ao concluir, contate o suporte.'
								)
							}
						})
						.finally(() => {
							this.FinishLoading()
						})
				} else {
					await this.$nextTick()
					const invalidPartnershipField = this.$el.querySelector(
						'#partnerships .field-error'
					)
					if (invalidPartnershipField) {
						window.jQuery(this.$el)
							.find('.nav-link[href="#partnerships"]')
							.tab('show')

						invalidPartnershipField.scrollIntoView({
							behavior: 'smooth',
							block: 'center',
						})
					} else {
						window.jQuery(this.$el)
							.find('.nav-link[href="#info"]')
							.tab('show')
						window.helpers.focusInvalid(this.$v.form, this)
					}
				}
			},
			async Delete() {
				useDeleteAlert().then(async result => {
					if (result.isConfirmed) {
						this.StartLoading()

						await window.api
							.call('post', '/delete-material', {
								material_id: this.material.id,
								organization_id: this.requester_selected_id,
							})
							.then(({ data }) => {
								if (data.response) {
									useConfirmation()

									this.$emit('refresh', {
										material: this.material,
										method: 'delete',
									})

									this.Close()
								} else {
									useError(
										'Houve um erro ao concluir, contate o suporte.'
									)
								}
							})
							.finally(() => {
								this.FinishLoading()
							})
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.tab-content {
		max-height: 730px;
		overflow: auto;
	}

	.modal-dialog {
		max-width: 90%;
	}

	.btn-primary {
		--newPrimaryBackgroundColor: #2196f3;
		--newPrimaryHover: hsl(207, 90%, 35%);

		background-color: var(--newPrimaryBackgroundColor);
		border-color: var(--newPrimaryBackgroundColor);
		border-radius: 0.8rem !important;
		padding: 1rem 1.5rem;
		height: 2.8rem;
		font-size: 1.1rem;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 8rem;

		&:hover {
			background-color: var(--newPrimaryHover);
			border-color: var(--newPrimaryHover);
		}
	}

	.btn-success {
		--successBackgroundColor: #19d319;
		--newSuccessHover: hsl(120, 79%, 30%);

		background-color: var(--successBackgroundColor);
		border-color: var(--successBackgroundColor);
		border-radius: 0.8rem !important;
		padding: 1rem 1.5rem;
		height: 2.8rem;
		font-size: 1.1rem;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 8rem;

		&:hover {
			background-color: var(--newSuccessHover);
			border-color: var(--newSuccessHover);
		}
	}

	.btn-danger {
		background-color: #b71c1c !important;
		border-color: #b71c1c !important;
		border-radius: 0.8rem !important;
		padding: 1rem 1.5rem;
		height: 2.8rem;
		font-size: 1.1rem;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 8rem;

		&:hover {
			background-color: hsl(0, 73%, 35%) !important;
			border-color: hsl(0, 73%, 35%) !important;
		}
	}

	.nav.nav-pills.nav-theme .nav-link {
		font-size: 1rem;
	}

	.form-check input:checked ~ label:after {
		background: var(--newPrimaryBackgroundColor);
	}

	fieldset {
		border: 1px solid var(--dark-light);
		border-radius: 0.5rem;
		padding: 0.1rem 1rem;
	}

	legend {
		display: inline;
		width: unset;
		padding: 0 10px;
		font-size: 1rem;
	}
</style>

<style lang="css">
	#modal-material .ql-editor {
		height: 17vh !important;
	}

	#modal-material .tuss-description-not-found {
		color: #eab308 !important;
	}

	#modal-material .form-control.tuss-code-not-found:focus,
	#modal-material .form-control.tuss-description-not-found:focus {
		border: 2px solid #eab308 !important;
	}
</style>
